import { Bath, ChefHat, Wrench, ArrowUpRight } from "lucide-react";

const SERVICE_BATHROOM =
  "https://images.unsplash.com/photo-1758448018619-4cbe2250b9ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwbW9kZXJuJTIwYmF0aHJvb20lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzc3Mjk1MDgxfDA&ixlib=rb-4.1.0&q=85";
const SERVICE_KITCHEN =
  "https://images.pexels.com/photos/20036481/pexels-photo-20036481.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const SERVICE_PLUMBING =
  "https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=940&q=80";

const services = [
  {
    id: "bathroom",
    icon: Bath,
    title: "Bathroom Design & Installation",
    blurb:
      "Complete bathroom renovations — designed, planned and fitted end-to-end by our own team. From full wet-rooms and family bathrooms to en-suites and cloakrooms, every trade is handled in-house.",
    image: SERVICE_BATHROOM,
    points: [
      "Full design & layout planning",
      "Tiling, plastering & decorating in-house",
      "Bathroom supply, fit & mastic sealant",
    ],
  },
  {
    id: "kitchen",
    icon: ChefHat,
    title: "Kitchen Design & Installation",
    blurb:
      "Full kitchen renovations delivered by one trusted team. Our gas engineers, plumbers, electricians, carpenters, tilers and decorators work together under one roof — so your timeline holds and your finish is flawless.",
    image: SERVICE_KITCHEN,
    points: [
      "Bespoke layout & cabinetry design",
      "Plumbing, gas & electrics for appliances",
      "Tiling, worktops & decoration",
    ],
  },
  {
    id: "plumbing",
    icon: Wrench,
    title: "Plumbing & Heating",
    blurb:
      "Gas Safe boiler installations, repairs and annual servicing. Full heating system upgrades, Gas Safety Certificates and everyday household plumbing — from dripping taps to complete re-pipes.",
    image: SERVICE_PLUMBING,
    points: [
      "Vaillant & Glow-worm boiler installs",
      "Heating system install & repair",
      "Gas Safety Certificates · general plumbing",
    ],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <span className="uppercase text-xs tracking-[0.3em] text-[#C9A24A] font-semibold">
              Our Services
            </span>
            <h2
              data-testid="services-title"
              className="mt-4 font-heading text-3xl lg:text-5xl text-[#1C2A39] font-medium tracking-tight"
            >
              One team. Every trade. Under one roof.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-base lg:text-lg text-[#5C6670] leading-relaxed">
              At C4 Plumbing &amp; Heating Ltd we deliver a professional,
              reliable service from design through to decoration. Our in-house
              team of gas engineers, plumbers, electricians, plasterers,
              carpenters, tilers and decorators means your project is run by
              one trusted crew — no sub-contractors, no finger-pointing, no
              delays.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((s, i) => (
            <article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              className={`group relative overflow-hidden bg-white border border-[#E8E5DD] hover:border-[#C9A24A] transition-colors ${
                i === 0 ? "lg:row-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className={`relative ${i === 0 ? "aspect-[4/5]" : "aspect-[16/10]"} overflow-hidden`}>
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
                <div className="absolute top-4 left-4 bg-[#F9F8F6]/95 backdrop-blur-sm w-11 h-11 grid place-items-center">
                  <s.icon
                    size={20}
                    strokeWidth={1.5}
                    className="text-[#C9A24A]"
                  />
                </div>
              </div>
              <div className="p-7">
                <h3 className="font-heading text-xl text-[#1C2A39] font-semibold leading-snug">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-[#5C6670] leading-relaxed">
                  {s.blurb}
                </p>
                <ul className="mt-5 space-y-2">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-2 text-xs text-[#1C2A39]"
                    >
                      <span className="w-1 h-1 bg-[#C9A24A]" />
                      {p}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`service-cta-${s.id}`}
                  onClick={() =>
                    document
                      .getElementById("quote")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                  className="mt-6 inline-flex items-center gap-2 text-sm font-heading font-semibold text-[#1C2A39] group-hover:text-[#C9A24A] transition-colors"
                >
                  Request quote for this
                  <ArrowUpRight size={16} strokeWidth={1.75} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
